import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import * as React from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import axiosInstance from "../../../Axios";
import useAuth from "../../../contexts/UserContext.tsx";

export default function AddSmartClassModal({
  open,
  onClose,
  classDetails,
  setReload,
}) {
  const { user } = useAuth();
  const addModalColumn = [
    {
      field: "category_id",
      headerName: "Category ID",
    },
    {
      field: "category_name",
      headerName: "Category",
      minWidth: 250,
    },
    {
      field: "crs_title",
      headerName: "Course Title",
      minWidth: 250,
      flex: 1,
    },
  ];

  const [centerName, setCenterName] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [addCourse, setAddCourse] = React.useState([]);
  const [allCourses, setAllCourses] = React.useState([]);
  const [hmName, setHmName] = React.useState(classDetails.hm_name);
  const [hmPhone, setHmPhone] = React.useState(classDetails.hm_phone);
  const params = useParams();
  const schoolID = params["id"];

  function CustomToolbarCourses() {
    return (
      <GridToolbarContainer
        sx={{ padding: 2, display: "flex", justifyContent: "space-between" }}
      >
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  React.useEffect(() => {
    const getCourses = async () => {
      try {
        const res = await axiosInstance.post("/getCourses", {
          auth_token: user.auth_token,
          user_id: user.user_id,
        });
        setAllCourses(res.data.data.courses);
      } catch (err) {
        toast.error(err.message);
      }
    };
    getCourses();
  }, [user.auth_token, user.user_id]);

  React.useEffect(() => {
    if (classDetails) {
      setHmName(classDetails.hm_name);
      setHmPhone(classDetails.hm_phone);
    }
  }, [classDetails]);

  const handleSubmit = async () => {
    if (centerName === "" || address === "") {
      toast.error("Please fill all the fields");
      return;
    } else if (addCourse.length === 0) {
      toast.error("Please select atleast one course");
      return;
    }
    try {
      const res = await axiosInstance.post("/AddCenter", {
        center_name: centerName,
        address: address,
        hm_name: hmName,
        hm_phone: hmPhone,
        crs_to_enroll: `[${addCourse}]`,
        school_id: schoolID,
        auth_token: user.auth_token,
      });
      if (res.data.data.status === 0) {
        throw new Error(res.data.data.msg);
      }
    } catch (err) {
      toast.error(err);
    } finally {
      setReload((prev) => !prev);
      handleClose();
    }
  };

  const handleClose = () => {
    setCenterName("");
    setAddress("");
    onClose();
  };

  const handleAddCourseSelectionChange = (selectionModel) => {
    setAddCourse(selectionModel);
  };
  return (
    <>
      {classDetails && (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
          <DialogTitle className="opacity-95">
            Add New Center
            <div className="text-sm opacity-60">{classDetails.school_name}</div>
          </DialogTitle>
          <DialogContent
            sx={{ display: "flex", gap: 1, flexDirection: "column" }}
          >
            <TextField
              autoFocus
              margin="dense"
              label="Center Name"
              variant="outlined"
              value={centerName}
              onChange={(event) => setCenterName(event.target.value)}
              size="small"
            />
            <TextField
              autoFocus
              margin="dense"
              label="Address"
              variant="outlined"
              value={address}
              onChange={(event) => setAddress(event.target.value)}
              size="small"
            />
            <TextField
              autoFocus
              margin="dense"
              label="Headmaster Name"
              variant="outlined"
              value={hmName}
              onChange={(event) => setHmName(event.target.value)}
              size="small"
            />
            <TextField
              autoFocus
              margin="dense"
              label="Headmaster Phone"
              variant="outlined"
              value={hmPhone}
              onChange={(event) => setHmPhone(event.target.value)}
              size="small"
            />
            {allCourses &&
              (allCourses.length > 0 ? (
                <div className="all-course-container">
                  <Typography
                    variant="h6"
                    sx={{ marginTop: "15px" }}
                    component="h2"
                  >
                    Courses
                  </Typography>
                  <DataGrid
                    columns={addModalColumn}
                    rows={allCourses}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    pagination
                    rowHeight={50}
                    sx={{ marginTop: "0.5em" }}
                    autoHeight={true}
                    getRowId={(row) => parseInt(row.crs_id)}
                    components={{
                      Toolbar: CustomToolbarCourses,
                    }}
                    checkboxSelection
                    onSelectionModelChange={handleAddCourseSelectionChange}
                  />
                </div>
              ) : (
                <Typography variant="h6" className="text-gray-400">
                  No courses available
                </Typography>
              ))}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleClose}
              variant="contained"
              sx={{
                backgroundColor: "#f45539",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#c9442d",
                },
              }}
            >
              Cancel
            </Button>
            <Button onClick={handleSubmit} variant="contained">
              Add
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
